// Lib
import { connect } from 'react-redux';

// Selectors
import { getCurrentBoardIdFromState } from '../../reducers/currentBoardId/currentBoardIdSelector';
import { getPublishPreviewPermissionIdForElementIdSelector } from '../../utils/permissions/permissionsSelector';

// Actions
import { validatePreviewPasswordHttp } from '../../element/elementPasswordService';
import { getPermissionsForBoard } from '../../utils/permissions/permissionsActions';
import { setPublishPreviewPasswordValidated } from '../preview/previewActions';

// Components
import BoardPasswordProtectedFormUI from './BoardPasswordProtectedFormUI';

// Errors
import AppError from '../../../common/error/AppError';

const onSubmitThunk =
    ({ password }) =>
    async (dispatch, getState) => {
        const state = getState();

        const elementId = getCurrentBoardIdFromState(state);
        const permissionId = getPublishPreviewPermissionIdForElementIdSelector(state, { elementId });

        const result = await validatePreviewPasswordHttp({ elementId, password, permissionId });

        if (!result.success) throw new AppError({ message: 'Something went wrong' });

        dispatch(setPublishPreviewPasswordValidated());
    };

const mapDispatchToProps = (dispatch) => ({
    dispatchOnMountDataFetch: ({ startingBoardId }) => dispatch(getPermissionsForBoard({ boardId: startingBoardId })),
    dispatchOnSubmit: ({ password }) => dispatch(onSubmitThunk({ password })),
});

export default connect(null, mapDispatchToProps)(BoardPasswordProtectedFormUI);
